import {actionTypes} from 'constants/constants';

const initialState = {
    showShare: false,
    showComment: false,
    showNew: false
};

export default function  (state = initialState, action) {
    switch (action.type) {
        case actionTypes.KUAKUA_SETSHARE:
            console.log(Object.assign({},state,action.data))
            return Object.assign({},state,action.data);
        case actionTypes.KUAKUA_SETCOMMENT:
            return Object.assign({},state,action.data);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/thefair/kuakuaTreeHole.js